import { useEffect } from 'react';

/**
 * A global hook that automatically injects data-label attributes into all <td> elements
 * based on their corresponding <th> headers. This powers the mobile card-style tables
 * without requiring manual JSX modifications across dozens of files.
 */
const useTableLabels = () => {
  useEffect(() => {
    const updateTableLabels = () => {
      const tables = document.querySelectorAll('.data-table');
      tables.forEach(table => {
        const headers = Array.from(table.querySelectorAll('thead th')).map(th => {
          return th.innerText.trim();
        });
        
        const rows = Array.from(table.querySelectorAll('tbody tr'));
        rows.forEach(row => {
          // Only target direct td children to avoid nested tables issues
          const cells = Array.from(row.children).filter(child => child.tagName.toLowerCase() === 'td');
          cells.forEach((cell, index) => {
            if (headers[index] && !cell.hasAttribute('data-label')) {
              cell.setAttribute('data-label', headers[index]);
            }
          });
        });
      });
    };

    // Initial run
    updateTableLabels();

    // Re-run whenever the DOM changes (e.g. data loaded, pagination clicked)
    const observer = new MutationObserver((mutations) => {
      // Check if any added nodes contain a table or tbody to avoid infinite loops on attribute changes
      let shouldUpdate = false;
      for (let mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldUpdate = true;
          break;
        }
      }
      if (shouldUpdate) {
        updateTableLabels();
      }
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    return () => observer.disconnect();
  }, []);
};

export default useTableLabels;
